import React from 'react';
import './Home.css';
import Product from './Product.js';

function Home(){
    return(
        <div className="home">
            <div className="home__container">
              <img 
              className="
              home__image"
                // src="https://s22581.pcdn.co/wp-content/uploads/2018/04/AWS-Worldwide-Public-Sector-Summit-2018-Washington-DC.png"
                src="https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220_.jpg"
              />  
              <div className="home__row">
                <Product
                  id="15651123156"
                  title="The lean startup"
                  price={29.99}
                  image="https://images-na.ssl-images-amazon.com/images/I/51Zymoq7UnL._AC_SY400_.jpg"
                  rating={3}
                />
                <Product
                  id="2664684231"
                  title="Kenwood kMix Stand Mixer for Baking, Stylish Kitchen Mixer with K-beater, Dough Hook and Whisk, 5 Litre Glass Bowl"
                  price={239.0}
                  image="https://th.bing.com/th?id=OP.jE4JZ%2biihZrK3A474C474&w=160&h=150&rs=1&o=5&pid=21.1"
                  rating={4}
                />
               
              </div>
              <div className="home__row">
                <Product 
                  id="456313654"
                  title="Samsung Curved LED Gaming Monitor"
                  price={129.99}
                  image="https://www.bhphotovideo.com/images/images2000x2000/samsung_34_c34h890wjn_curved_monitor_1339228.jpg"
                  rating={5}
                />
                <Product 
                  id="26165461234"
                  title="Amzon Echo (3rd generation) | Smart speaker with Alexa, Charcoal Fabric"
                  price={98.99}
                  image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQY9TuqzOz_gfkeXXgcEvsF1v3-7F42aIGxYIzdR7g64WywBb3xL6BaM2Z3JHa8wRF63Puag2dsMA&usqp=CAc"
                  rating={5}
                />
                <Product 
                  id="316541164"
                  title="New Apple iPad Pro (12.9-inch, Wi-Fi, 128GB) - Silver (4th Generation)"
                  price={598.99}
                  image="https://cdn.shoplightspeed.com/shops/606657/files/19193072/apple-new-129-inch-ipadpro-wi-fi-128gb-4th-generat.jpg"
                  rating={4}
                />
              </div>
              <div className="home__row">
                <Product 
                   id="94356432"
                   title="Samsung Curved LED Gaming Monitor"
                   price={1094.99}
                   image="https://img.global.news.samsung.com/in/wp-content/uploads/2017/12/Curved-Monitor-N1.jpg"
                   rating={5}
                />
              </div>
            </div>
        </div>
    )
}

export default Home;